<template>
  <ResizablePage>
    <template v-slot:content="conentProps">
      <v-container fluid v-bind:style="{ height: conentProps.tableHeight + 'px' }" class="overflow-y-auto" fill-height>
        <v-layout justify-center>
          <v-row style="max-width: 900px">
            <validation-observer style="width: 100%"
                                 class="px-5"
                                 ref="form_validation"
            >
              <v-form
                @submit.prevent="submit"
                :readonly="!editable">

                <v-expansion-panels multiple flat hover v-model="panels">
                  <v-expansion-panel>
                    <v-expansion-panel-header>{{ $t("view.subject.group.base") }}</v-expansion-panel-header>
                    <v-expansion-panel-content>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.subject.country"
                            rules="required"
                          >
                            <CountryField
                              v-model="country"
                              :error-messages="errors"
                              :label="$t('view.subject.country')"
                              required
                              clearable />
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.subject.name"
                            rules="required|max:100"
                          >
                            <v-text-field
                              v-model="name"
                              :counter="100"
                              :error-messages="errors"
                              :label="$t('view.subject.name')"
                              required
                              clearable
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.subject.id"
                            rules="max:30"
                          >
                            <v-text-field
                              v-model="id"
                              :counter="50"
                              :error-messages="errors"
                              :label="$t('view.subject.id')"
                              required
                              clearable
                            >
                              <template v-slot:append>
                                <v-tooltip v-if="country !== null && id !== null && id.length > 0" bottom open-delay="500">
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                      class="clickable-icon"
                                      @click="searchSubject"
                                      v-on="on">
                                      search
                                    </v-icon>
                                  </template>
                                  <span>{{ $t("view.subject.tooltip.search") }}</span>
                                </v-tooltip>

                              </template>
                            </v-text-field>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.subject.vat_number"
                            rules="max:30"
                          >
                            <v-text-field
                              v-model="vatNumber"
                              :counter="50"
                              :error-messages="errors"
                              :label="$t('view.subject.vat_number')"
                              required
                              clearable
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.subject.note"
                            rules="max:100"
                          >
                            <v-text-field
                              v-model="note"
                              :counter="100"
                              :error-messages="errors"
                              :label="$t('view.subject.note')"
                              required
                              clearable
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                            <v-checkbox
                              v-model="active"
                              :label="$t('view.subject.active')"
                            ></v-checkbox>
                        </v-col>
                      </v-row>

                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header>{{ $t("view.subject.group.contacts") }}
                      <v-spacer />
                      <v-btn v-if="editable" v-on:click.stop="updateContact({})"
                             small
                             elevation="0"
                             max-width="100px"
                             class="mr-4"
                             color="primary"
                      >
                        {{ $t("view.subject.add_contact") }}
                      </v-btn>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-list>
                        <v-list-item v-for="item in contacts" :key="item.vehicleId">
                          <v-list-item-icon class="mx-2 px-0"><v-icon>{{ getContactIcon(item) }}</v-icon></v-list-item-icon>
                          <v-list-item-title>
                            {{ contactToText(item) }}
                            <template v-if="item.note !== null">
                              &nbsp;
                              <span class="grey--text">{{ item.note }}</span>
                            </template>
                            &nbsp;
                            <span v-if="item.registered" class="contact-tag registered">{{ $t('view.subject.flag_registered') }}</span>
                            <span v-if="item.billing" class="contact-tag billing">{{ $t('view.subject.flag_billing') }}</span>
                            <span v-if="item.communication" class="contact-tag communication">{{ $t('view.subject.flag_communication') }}</span>
                          </v-list-item-title>
                          <v-list-item-action>
                            <v-tooltip bottom open-delay="500">
                              <template v-slot:activator="{ on }">
                                <v-btn icon
                                       @click="updateContact(item)"
                                       v-on="on"
                                       v-if="editable">
                                  <v-icon color="grey lighten-1">edit</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("view.subject.tooltip.update_contact") }}</span>
                            </v-tooltip>
                          </v-list-item-action>
                          <v-list-item-action>
                            <v-tooltip bottom open-delay="500">
                              <template v-slot:activator="{ on }">
                                <v-btn icon
                                       @click="removeContact(item)"
                                       v-on="on"
                                       v-if="editable">
                                  <v-icon color="grey lighten-1">delete</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("view.subject.tooltip.remove_contact") }}</span>
                            </v-tooltip>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-content>
                  </v-expansion-panel>


                </v-expansion-panels>
              </v-form>
            </validation-observer>
          </v-row>
        </v-layout>

        <v-snackbar
          v-model="showError"
          bottom
          light
          timeout="-1"
          color="red lighten-4"
        >
          {{ errorMessage }}

          <template v-slot:action="{ attrs }">
            <v-btn
              color="indigo"
              text
              v-bind="attrs"
              @click="showError = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>

        <ContactDialog
          ref="contactDialog"
          v-on:updated="storeContact" />
        <SubjectSearchDialog
          ref="searchDialog"
          v-on:update="updateSubject" />
      </v-container>
    </template>
  </ResizablePage>
</template>

<script>
import utils from "@/utils";
import ResizablePage from "@/components/ResizablePage";
import CountryField from "@/components/fields/CountryField.vue";
import ContactDialog from "@/components/dialogs/ContactDialog.vue";
import SubjectSearchDialog from "@/components/dialogs/SubjectSearchDialog.vue";

export default {
  name: "SubjectView",
  components: { SubjectSearchDialog, ContactDialog, CountryField, ResizablePage },
  data() {
    return {
      editable: this.canWrite("subject"),
      canLeave: !this.canWrite("subject"),
      panels: [0, 1],

      name: "",
      id: null,
      vatNumber: null,
      active: true,
      note: null,
      moduleContracts: false,
      country: null,
      contacts: [],
      record: null,

      showError: false,
      errorMessage: null
    };
  },

  methods: {
    async store() {
      if (this.$refs.form_validation.validate()) {
        let object = {
          name: this.name,
          id: this.id,
          vatNumber: this.vatNumber,
          active: this.active,
          note: this.note,
          countryCode: this.country,
          contacts: this.contacts
        };

        let params = {
          module: "subject",
          object: object
        };

        if (!utils.isObjectEmpty(this.$store.state.data.record)) {
          params.id = this.record.subjectId;
          object.companyId = this.record.companyId;
          object.lastChange = this.record.lastChange;
        }

        let response = await this.$store.dispatch("data/storeRecord", params);

        if (response.error) {
          this.showError = true;
          this.errorMessage = response.message;
        } else {
          this.canLeave = true;
          this.$router.close({ name: "data/companies" });
        }
      }
    },

    async remove() {
      let params = {
        module: "subject",
        id: this.record.subjectId
      };

      let response = await this.$store.dispatch("data/deleteRecord", params);

      if (response.error) {
        this.showError = true;
        this.errorMessage = response.message;
      } else {
        this.canLeave = true;
        this.$router.close({ name: "data/companies" });
      }
    },

    cancel() {
      this.canLeave = true;
      this.$router.close({ name: "data/companies" });
    },

    contactToText(contact) {
      if (contact.type === "email")
        return contact.contactValue;
      else if (contact.type === "phone")
        return contact.contactValue;
      else if (contact.type === "address") {
        return utils.formatLocation(contact.contactValue, true);
      } else
        return ""
    },

    updateContact(contact) {
      this.$refs.contactDialog.open(contact);
    },

    storeContact(contact) {
      if (this.contacts.filter(c => c === contact).length === 0) {
        this.contacts.push(contact);
        this.contacts.sort((a, b) => { a.type.localeCompare(b.type); });
      }
    },

    updateSubject(subject) {
      if (subject.use.name)
        this.name = subject.name;
      if (subject.use.id)
        this.id = subject.id;
      if (subject.use.vatNumber)
        this.vatNumber = subject.vatNumber;
      if (subject.use.address) {
        const pa = subject.contacts.filter(a => a.type === "address" && a.registered === true);
        if (pa.length > 0) {
          const spa = this.contacts.filter(a => a.type === "address" && a.registered === true);
          console.log(spa);
          if (spa.length === 1)
            spa[0].contactValue = pa[0].contactValue;
          else
            this.contacts.push(pa[0]);
        }
      }
    },

    removeContact(contact) {
      this.contacts = this.contacts.filter(c => c !== contact);
    },

    getContactIcon(contact) {
      if (contact !== null) {
        if (contact.type === "email")
          return "alternate_email";
        else if (contact.type === "phone")
          return "phone";
        else if (contact.type === "address")
          return "place";
      }
      return ""
    },

    searchSubject() {
      this.$refs.searchDialog.open(this.country, this.id);
    }
  },

  watch: {
    "$store.state.data.record": function() {
      if (this.$store.state.data.module === "subject" && this.$store.state.data.record !== null) {
        let record = this.$store.state.data.record;

        this.name = record.name || null;
        this.id = record.id || null;
        this.vatNumber = record.vatNumber || null;
        this.active = (record.active === undefined || record.active === true);
        this.note = record.note || null;
        this.country = record.countryCode || null;
        this.contacts = record.contacts || [];
        this.record = record;
      }
    },

    "$store.state.data.activeEvent": function() {
      const e = this.$store.state.data.activeEvent;
      if (e != null && e.target === "view") {
        try {
          if (e.click !== undefined) {
            switch (e.click) {
              case "store":
                this.store();
                break;
              case "cancel":
                this.cancel();
                break;
              case "delete":
                this.remove();
                break;
            }
          }
        } finally {
          this.$store.dispatch("data/processEvents");
        }
      }
    }
  },

  mounted() {
    this.$store.dispatch("data/resetEvents");

    if (this.$route.params.id === "new")
      this.$store.dispatch("data/fetchRecord", { module: "subject" });
    else
      this.$store.dispatch("data/fetchRecord", { module: "subject", id: this.$route.params.id });
  },

  async beforeRouteLeave(to, from, next) {
    if (this.canLeave)
      next();
    else {
      const answer = window.confirm(this.$t("view.leave_msg"));
      if (answer) {
        next();
      } else {
        next(false);
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.contact-tag
  font-size: 70%
  margin-left: 5px
  padding: 2px 5px
  background-color: royalblue
  color: white
  border-radius: 5px
  position: relative
  top: -2px

.contact-tag.registered
  background-color: royalblue

.contact-tag.billing
  background-color: #c06432

.contact-tag.communication
  background-color: mediumseagreen

.clickable-icon
  cursor: pointer
</style>